import type React from 'react';
import { useAuthModal } from '@features/common/protected-auth-route/model.ts';
import xhr from '@shared/config/api';
import * as st from './styles.module.scss';

export const ButtonLogin: React.FC = () => {
  const { openAuth } = useAuthModal();
  const login = () => {
    const isWebView = window.navigator.userAgent.toLowerCase().includes('wv');
    if (isWebView) {
      /**
       * Костыль для перехвата webView нажатия на кнопку логин
       *
       * Выполняется фейковый запрос, который нужен только для
       * открытия окна авторизации в мобильном приложении
       */

      xhr.get('/open/mobile/login/');
    }

    openAuth();
  };

  return (
    <button id="login_btn" className={st.login} onClick={login}>
      Войти
    </button>
  );
};
